import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-navig',
  templateUrl: './navig.component.html',
  styleUrls: ['./navig.component.css']
})
export class NavigComponent implements OnInit {

  notHomepage = true;

  href = '';

  constructor(private router: Router) {
    router.events.subscribe(() => {
      this.href = this.router.url;
      console.log(this.href);

      if (this.href === '/about-me' || this.href === '/') {
        // console.log('we are home');
        this.notHomepage = false;
      } else {
        this.notHomepage = true;
      }
    });
  }

  ngOnInit() {
    if (this.href === '/about-me' || this.href === '/') {
      console.log('we are home');
      this.notHomepage = false;
    } else {
      this.notHomepage = true;
    }
  }

}
